import { IRootState } from '..';

export const SELECTOR_PLAYBACK_READY = (state: IRootState) => state.Playback.ready;
export const SELECTOR_PLAYBACK_CAN_PLAY = (state: IRootState) => state.Playback.canPlay;
export const SELECTOR_PLAYBACK_PAUSED = (state: IRootState) => state.Playback.paused;
export const SELECTOR_PLAYBACK_TIME_PERCENT = (state: IRootState) => state.Playback.timePercent;
export const SELECTOR_PLAYBACK_BUFFER_INDICATOR_PERCENT = (state: IRootState) => state.Playback.bufferIndicatorPercent;
export const SELECTOR_PLAYBACK_VOLUME_PERCENT = (state: IRootState) => state.Playback.volumePercent;
export const SELECTOR_PLAYBACK_IS_MUTED = (state: IRootState) => state.Playback.isMuted;
export const SELECTOR_PLAYBACK_CURRENT_TIME = (state: IRootState) => state.Playback.currentTime;
export const SELECTOR_PLAYBACK_DURATION = (state: IRootState) => state.Playback.duration;
export const SELECTOR_PLAYBACK_HAS_NATIVE_HLS = (state: IRootState) => state.Playback.hasNativeHLS;
export const SELECTOR_PLAYBACK_PLAYBACK_RATE = (state: IRootState) => state.Playback.playbackRate;
export const SELECTOR_PLAYBACK_FIRST_PLAY = (state: IRootState) => state.Playback.firstPlay;
export const SELECTOR_PLAYBACK_IS_CLOSE_TO_LIVE_EDGE = (state: IRootState) => state.Playback.isCloseToLiveEdge;
export const SELECTOR_PLAYBACK_IS_SEEKING = (state: IRootState) => state.Playback.isSeeking;
export const SELECTOR_PLAYBACK_VIDEO_DIMENSIONS = (state: IRootState) => state.Playback.videoDimensions;
